export default __webpack_public_path__ + "static/media/UserGuide_zh_TW.0a2b89be.pdf";